import { render, staticRenderFns } from "./part-f.vue?vue&type=template&id=6b8e8d99&"
import script from "./part-f.vue?vue&type=script&lang=js&"
export * from "./part-f.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports